import { AxiosInstance, InternalAxiosRequestConfig } from 'axios';
import { store } from 'src/store/rootStore';
import settingsService from 'src/services/settings/settings.service';
import { v4 as generateId } from 'uuid';
import refreshTokenService from 'src/services/refresh-token/refresh-token.service';
const setBaseUrl = async (config: InternalAxiosRequestConfig) => {
    const { baseUrl } = await settingsService.getSettings();
    config.baseURL = baseUrl;
    return config;
};

const addHeaders = (config: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
    const uuid = generateId();
    const { accessToken } = store.getState().session;
    config.headers.Authorization = `Bearer ` + accessToken;
    config.headers['x_b3_traceid'] = uuid;
    config.headers['X-Correlation-ID'] = uuid;
    return config;
};

const onRequest = async (
    config: InternalAxiosRequestConfig
): Promise<InternalAxiosRequestConfig> => {
    await refreshTokenService.checkAndUpdateToken();
    return config;
};

export function setupRequestInterceptorTo(axiosInstance: AxiosInstance) {
    axiosInstance.interceptors.request.use(setBaseUrl);
    axiosInstance.interceptors.request.use(addHeaders);
    axiosInstance.interceptors.request.use(onRequest);
}
